import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { FaGithub, FaLinkedinIn, FaTwitter, FaInstagram, FaArrowRight } from 'react-icons/fa';
import { HiOutlineDocumentDownload } from 'react-icons/hi';
import './Home.css';

const roles = ["Machine Learning Engineer", "Full Stack Developer"];


const Home = () => {
  const [text, setText] = useState('');
  const [isDeleting, setIsDeleting] = useState(false);
  const [loopNum, setLoopNum] = useState(0);
  const [delta, setDelta] = useState(150);


  // Typing effect logic
  useEffect(() => {
    let ticker = setInterval(() => {
      let i = loopNum % roles.length;
      let fullText = roles[i];
      let updatedText = isDeleting 
        ? fullText.substring(0, text.length - 1) 
        : fullText.substring(0, text.length + 1);

      setText(updatedText);

      if (isDeleting) {
        setDelta(50); 
      } else {
        setDelta(120); 
      }

      if (!isDeleting && updatedText === fullText) {
        setIsDeleting(true);
        setDelta(3000); 
      } else if (isDeleting && updatedText === '') {
        setIsDeleting(false);
        setLoopNum(loopNum + 1);
        setDelta(200); 
      }
    }, delta);

    return () => clearInterval(ticker);
  }, [text, delta, isDeleting, loopNum]); 






  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      if (window.lenis) {
        window.lenis.scrollTo(element, { offset: -80 });
      } else {
        const offset = 80;
        const bodyRect = document.body.getBoundingClientRect().top;
        const elementRect = element.getBoundingClientRect().top;
        const elementPosition = elementRect - bodyRect;
        const offsetPosition = elementPosition - offset;

        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
      }
    }
  };


  const fadeInUp = {
    initial: { opacity: 0, y: 30 },
    animate: { opacity: 1, y: 0 },
    transition: { duration: 0.8, ease: [0.6, -0.05, 0.01, 0.99] }
  };

  const stagger = {
    animate: {
      transition: {
        staggerChildren: 0.1
      }
    }
  };

  return (
    <div className="home-container" id="home">
      {/* Background Ambience */}
      <div className="background-effects">
        <div className="gradient-orb orb-1" />
        <div className="gradient-orb orb-2" />
        <div className="gradient-orb orb-3" />
        <div className="grid-overlay" />
      </div>

      <motion.div 
        className="content-wrapper"
        initial="initial"
        animate="animate"
        variants={stagger}
      >
        <motion.div className="badge-container" variants={fadeInUp}>
          <span className="greeting-badge">👋 Welcome to my Portfolio</span>
        </motion.div>

        <motion.h1 className="hero-title" variants={fadeInUp}>
          Hi, I'm <br />
          <span className="name-highlight">Rahul Mishra</span>
        </motion.h1>

        <motion.div className="typewriter-container" variants={fadeInUp}>
          <span className="typewriter-prefix">I'm a </span>
          <span className="typewriter-text">{text}</span>
          <span className="cursor-premium" />
        </motion.div>

        <motion.p className="description-text" variants={fadeInUp}>
I love building things that involve <span className="text-gradient-mini">code and creativity</span>. <br />
          Obsessed with how <span className="text-gradient-mini">Neural Networks</span> work and passionate about <span className="text-gradient-mini">Full-Stack </span> development and <span className="text-gradient-mini">NLP</span>.
        </motion.p>

        <motion.div className="cta-group" variants={fadeInUp}>
          <motion.button 
            className="primary-btn"
            onClick={() => scrollToSection('projects')}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            View Projects <FaArrowRight />
          </motion.button>
          
          <motion.button 
            className="secondary-btn"
            onClick={() => scrollToSection('contact')}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            Contact Me
          </motion.button>

          <motion.button 
            className="cv-btn"
            onClick={() => window.open('https://drive.google.com/file/d/1NiKZTQX-gm8bVaqYICl4rv8-OOCb9sZ1/preview', '_blank')}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            Download CV <HiOutlineDocumentDownload />
          </motion.button>
        </motion.div>

        <motion.div className="social-bar" variants={fadeInUp}>
          {[
            { Icon: FaGithub, link: "https://github.com/machinelearningprodigy", brand: "github" },
            { Icon: FaLinkedinIn, link: "https://www.linkedin.com/in/rahul-mishra-9a8826269/", brand: "linkedin" },
            { Icon: FaTwitter, link: "https://x.com/NitishM66803568", brand: "twitter" },
            { Icon: FaInstagram, link: "https://www.instagram.com/rahul9076mishra/", brand: "instagram" }
          ].map((item, index) => (
            <motion.a
              key={index}
              href={item.link}
              target="_blank"
              rel="noopener noreferrer"
              className={`social-link ${item.brand}`}
              initial={{ opacity: 0, scale: 0 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ delay: 1 + index * 0.1 }}
            >
              <item.Icon />
            </motion.a>
          ))}
        </motion.div>
      </motion.div>

    </div>
  );
};

export default Home;